import { render, staticRenderFns } from "./ThemeSynthFresh.vue?vue&type=template&id=e4a28b54&scoped=true&"
import script from "./ThemeSynthFresh.vue?vue&type=script&lang=js&"
export * from "./ThemeSynthFresh.vue?vue&type=script&lang=js&"
import style0 from "./ThemeSynthFresh.vue?vue&type=style&index=0&id=e4a28b54&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4a28b54",
  null
  
)

export default component.exports